module.exports = __webpack_public_path__ + "6344c988ae29fcee790a20e9bfe84779.jpg";